import { takeEvery, put } from 'redux-saga/effects';
import { delay } from 'redux-saga';

import {
    NOTIFICATION_CREATE,
    addNotification,
    removeNotification
} from './notifyModule';


export function* handleNotification(action) {
    yield put(addNotification(action.notification));
    yield delay(6000);
    yield put(removeNotification(action.notification.get('uid')));
}


export function* watchNotifications() {
    yield takeEvery(NOTIFICATION_CREATE, handleNotification);
}
